export default {
  about: {
    XY: '上海旭宇信息科技有限公司',
    aboutUs: '关于我们',
    aboutUsText1: '上海旭宇信息科技有限公司的故事始于2004年，是一家专注于物联网全场景应用，集研发、生产、销售于一体的高新技术企业。我们是一家从事GPS定位行业的上海市高新技术企业，以“成为领先的物联网服务提供商”为愿景，业务包括：数字物流、车位数字化服务、宠物定位数字化服务、便携式定位器。我们的智能移动产品应用广泛，涵盖货物运输跟踪、贵重设备防盗、人员安全管理、宠物防走失、儿童及老年人防走失等多种使用场景。通过这些产品，客户可以远程管理关键资产，以提高运营效率，确保人员安全，降低维护成本，防范财务风险，最终提高服务能力。公司拥有100名办公室员工和2个研发中心，以及20年的技术经验，赢得了3000+家公司的信任。',
    aboutUsText2: '旭宇以客户为核心，从企划、开发、生产、交付、售后全方位对接客户，为客户产品的全生命周期提供完整、全面的服务。在项目前期，充分了解客户的产品需求，着眼于市场，确定产品设计方向。同时，旭宇强大的研发和强大的供应链，最大程度地缩短了量产周期，为产品的高质量呈现提供了最有效、最专业的支持。',
    reasonsTitle:'为什么选择我们',
    reasonsItemTitle1:'精准定位技术',
    reasonsItemText1:'我们持续投入研发，采用先进的定位技术，确保您的追踪体验精准无误，领先行业标准。',
    reasonsItemTitle2:'多样化产品线',
    reasonsItemText2:'无论是个人、家庭还是企业需求，我们提供全方位的定位解决方案，总有一款产品适配您的需求。',
    reasonsItemTitle3:'全面安全保障',
    reasonsItemText3:'数据加密技术与严格隐私政策相结合，为您的位置信息保驾护航，让您安心享受定位服务。',
    reasonsItemTitle4:'专业售后服务',
    reasonsItemText4:'我们拥有专业的售后团队，提供完善的售后服务方案，7*24小时在线，1对1或多对1服务。',
    teamTitle:'我们的团队',
    teamItemTitle1:'产品部',
    teamItemText1:'深谙市场脉搏，专注于将客户需求转化为创新且实用的产品，确保每一款产品都能满足您的期望。',
    teamItemTitle2:'研发部',
    teamItemText2:'拥有强大的技术实力和创新能力，致力于为您打造高品质、高性能的产品和平台，为您提供持续的技术支持和保障。',
    teamItemTitle3:'业务部',
    teamItemText3:'精通市场策略，能够精准把握商机，为您量身定制合作方案，确保您的投资回报最大化。',
    teamItemTitle4:'产品市场部',
    teamItemText4:'凭借敏锐的市场洞察力和专业的营销策略，确保我们的产品始终站在市场前沿，为您的业务增长提供有力支持。',
    teamItemTitle5:'售后部',
    teamItemText5:'我们的专业售后团队始终以客户为中心，提供及时、高效、全面的技术支持和服务，确保您在使用我们的产品时获得无忧的体验。',
    dreamText1:'以你的梦想为动力',
    dreamText2:'我们为全球客户提供技术和优质产品',
    honorTitle:'资质荣誉'
  },
  connection:{
    contactUs:'联系我们',
    contactUsItemTitle1:'总部',
    contactUsItemText1:'上海市闵行区马桥镇紫东路55号10号楼（联东U谷人工智能科创园）',
    contactUsItemTitle2:'分部',
    contactUsItemText2:'深圳市龙华区骏华北路5号瑞云财富大厦201室',
    contactUsItemTitle3:'电话',
    contactUsItemText3:'400-626-5529',
    contactUsItemTitle4:'邮箱',
    contactUsItemText4:'vip@02163.com',
  },
  home:{
    xyLocator:'旭宇定位器',
    locatorText:'随时随地，有迹可循',
    vehicleTex3:'掌控每一程，更智能、更安全',
    partnerText:'我们的产品赢得了很多客户的信赖和支持。我们将不断开发和维护更多的优质客户，并提供专业的产品服务支持',
    productSeries:'产品系列',
    technicalExperience:'技术经验',
    researchAndDevelopmentCenter:'研发中心',
    cooperativeClient:'合作客户',
    year:'年',
    xyTechnology:'旭宇科技',
    viewMore:'查看更多',
    worryFreePositioning:'定位无忧，精准每一刻',
    aboutLargeText:'旭宇的故事始于2004年，专注于物联网全场景应用，集研发、生产、销售于一体。我们是一家从事GPS定位行业的上海市高新技术企业，以“成为领先的物联网服务提供商”为愿景，业务包括：数字物流、车位数字化服务、宠物定位数字化服务、便携式定位器。我们的智能移动产品应用广泛，涵盖货物运输跟踪、贵重设备防盗、人员安全管理、宠物防走失、儿童及老年人防走失等多种使用场景。通过这些产品，客户可以远程管理关键资产，以提高运营效率，确保人员安全，降低维护成本，防范财务风险，最终提高服务能力。公司拥有100名办公室员工和2个研发中心，以及20年的技术经验，赢得了3000+家公司的信任。',
    productsTitle:'主要产品',
    productText:'多款定位产品供您选择，智享平台，精准高效，安心每一程',
    productBlueTooth:'蓝牙信标',
    solutionsTitle:'解决方案',
    solutionsItemTitle1:'循环包装数字化解决方案',
    solutionsItemText1:'旭宇载具系统结合数字化应用、物联网技术,构建基于循环载具为基础的“标准化+智能化+互联网化”的智慧数字化平台,为载具赋予数字生命,实现可知、可视、可管、可追溯。',
    solutionsItemTitle2:'车载定位解决方案',
    solutionsItemText2:'旭宇车载定位平台基于现代信息技术的综合性方案，整合物联网、大数据、云计算等先进技术，定位产品通过4G、5G网络，将车辆数据实时传输到后台管理系统。平台可以实时了解车辆的行驶轨迹、速度、停留等相关信息，为车辆调度、路线规划、故障预警、管理等提供有力的支撑。',
    partnersTitle:'他们都选择了旭宇',
    partnersText:'我们的产品赢得了很多客户的信赖和支持。我们将不断开发和维护更多的优质客户，并提供专业的产品服务支持',
    footerText1:'总部：上海市闵行区马桥镇紫东路55号10号楼（联东U谷人工智能科创园）',
    footerText2:'分部：深圳市龙华区骏华北路5号瑞云财富大厦201室',
    footerText3:'邮箱：vip@02163.com',
    wxErcode:'微信公众号'
  },
  navigation:{
    index:'首页',
    productCenter:'产品中心',
    solution:'解决方案',
    digitalSolutionsForCircularPackaging:'循环包装数字化解决方案',
    digitalSolutionForVehiclePositioning:'车载定位数字化解决方案',
    aboutUs:'关于我们',
    contactUs:'联系我们',
  },
  dSCircularPackaging:{
    dSCircularPackagingTitle:'循环包装数字化解决方案',
    doYouHaveTheseTroubles:'您是否存在这些困扰',
    issuesItemtitle1:'管理成本高',
    issuesItemtext1:'员工需要每天对内场载具进行盘点，费时费力又耗钱',
    issuesItemtitle2:'周转率低',
    issuesItemtext2:'上下游信息不透明、不同步，单元物流载具长期空置，未反复投入使用，整体使用率低下',
    issuesItemtitle3:'丢失率高',
    issuesItemtext3:'缺乏有效的全流程全生命周期的监管手段，管理滞后，追溯困难导致载具丢失现象严重。',
    issuesItemtitle4:'使用率低',
    issuesItemtext4:'载具的封闭使用导致大量重复性采购或超额采购，采购无数据支撑',
    issuesItemtitle5:'黑盒管理',
    issuesItemtext5:'载具在某一环节流转点数量、状态等实时信息，增加物流成本',
    weWillProvideYouWithProfessionalSolutions:'我们将为您提供专业的解决方案',
    digitalSystemForZhituoVehicles:'智驼载具数字化系统',
    solutionsText:'系统结合数字化应用、物联网技术，构建基于循环载具为基础的“标准化+智能化+互联网化”的智慧数字化平台，为载具赋予数字生命,实现可知、可视、可管、可追溯。',
    solutionsText1:'可知',
    solutionsText2:'可视',
    solutionsText3:'可管',
    solutionsText4:'可追溯',
    advantageItemTitle1:'降本增效',
    advantageItemText1:'通过旭宇载具数字化平台的数据支撑，有效地避免重复采购，资源闲置，大大提高载具的流转效率',
    advantageItemTitle2:'物流可视化',
    advantageItemText2:'对物流载具的跟踪，可以帮助起意构建物流最小颗粒可视化，实现货物跟踪从"跟车"升级为“跟拖”',
    advantageItemTitle3:'物流自动化',
    advantageItemText3:'依托旭宇载具数字化平台解决方案实现了对载具的在线管理，自动化管理和流转',
    advantageItemTitle4:'物流实时性',
    advantageItemText4:'通过数据采集和分析，对运输环节实时监测，为安全运输提供数据支撑',
    architectureTitle:'方案架构',
    highlightsTitle:'核心亮点',
    highlightsText:'电脑端、小程序双平台',
    highlightsItemTitle1:'资产设备实时定位',
    highlightsItemText1:'显示当前资产设备位置，并显示当前设备状态',
    highlightsItemTitle2:'调拨轨迹',
    highlightsItemText2:'高效查货品，可实时跟踪查询行驶轨迹',
    highlightsItemTitle3:'调拨记录',
    highlightsItemText3:'记录资产设备从各网点的调拨记录',
    highlightsItemTitle4:'网点管理',
    highlightsItemText4:'实时掌握库存情况，资产设备动销情况等',
    highlightsItemTitle5:'电子安全围栏',
    highlightsItemText5:'在网点以及风险区域画上电子围栏，可以设置设备进出围栏报警',
    highlightsItemTitle6:'报警管理',
    highlightsItemText6:'多种智能预警，监测异常事件并及时干预',
    highlightsItemTitle7:'多层级客户管理',
    highlightsItemText7:'有效管理多客户',
    highlightsItemTitle8:'大屏展示',
    highlightsItemText8:'可同时在地图上展示网点以及资产设备，方便调度',
    scenariosTitle:'应用场景',
    scenariosText:'适用于汽车零部件、化工、食品、生鲜、大宗商品、家电产品等循环包装领域 ，部分举例：',
    scenariosText1:'实现箱货统管，循环利用，助力智慧供应链。',
    scenariosItemLabel1:'卡板箱',
    scenariosItemLabel2:'网格物料',
    scenariosItemLabel3:'金属周转箱',
    scenariosItemLabel4:'塑料托盘',
    scenariosItemLabel5:'电池包料架',
    scenariosItemLabel6:'围板箱',
    locatorsTitle:'相关定位器',
  },
  product:{
    productTitle:'产品中心',
    productText:'以专业和用心驱动每一次安心出行',
    reasonsTitle:'为什么选择旭宇定位产品',
    reasonsText1:'多种定位方式',
    reasonsText2:'搭配云平台',
    reasonsText3:'隐私安全保障',
    reasonsText4:'专业售后和技术支持',
  },
  productDetail:{
    productDetailTitle:'产品详情',
    gobackProduct:'返回产品中心',
    productHighlights:'产品亮点',
    productParameters:'产品参数',
    project:'项目',
    specification:'规格',
    series:'系列',
    locator:'定位器',
    d98Brighttext1:'大容量电池 寿命3年以上',
    d98Brighttext2:'九重定位技术 覆盖盲点',
    d98Brighttext3:'自定义上报周期 满足不同场景',
    d98Brighttext4:'智能预警 资产移动主动推送',
    d98Brighttext5:'­异常预警 非法拆卸主动报警',
    d98Brighttext6:'IP65工业级设计 不惧雨淋冲洗',
    d98ArgumentKey1:'网络',
    d98ArgumentValue1:'4G CAT1',
    d98ArgumentKey2:'频段',
    d98ArgumentValue2:'国内全网通',
    d98ArgumentKey3:'LED指示灯',
    d98ArgumentValue3:'不支持',
    d98ArgumentKey4:'定位方式',
    d98ArgumentValue4:'GPS+WiFi+4G\\WiFi+4G',
    d98ArgumentKey5:'GPS定位精度',
    d98ArgumentValue5:'5米',
    d98ArgumentKey6:'WiFi定位精度',
    d98ArgumentValue6:'20米',
    d98ArgumentKey7:'LBS定位精度',
    d98ArgumentValue7:'1公里',
    d98ArgumentKey8:'上报周期',
    d98ArgumentValue8:'静止1天/次，运动1小时/次（可自定义）',
    d98ArgumentKey9:'工作平均电流',
    d98ArgumentValue9:'18.8mA',
    d98ArgumentKey10:'深度休眠电流',
    d98ArgumentValue10:'4uA',
    d98ArgumentKey11:'电池电压',
    d98ArgumentValue11:'3.7V',
    d98ArgumentKey12:'运动传感器',
    d98ArgumentValue12:'支持',
    d98ArgumentKey13:'电池容量',
    d98ArgumentValue13:'标配：4400mAH（选配：2200mAH）',
    d98ArgumentKey14:'供电方式',
    d98ArgumentValue14:'电池供电',
    d98ArgumentKey15:'充电功率',
    d98ArgumentValue15:'不可充电，不可拆卸',
    d98ArgumentKey16:'充电接口',
    d98ArgumentValue16:'--',
    d98ArgumentKey17:'电池工作时长',
    d98ArgumentValue17:'5年2200次\\10000次（两节电池）',
    d98ArgumentKey18:'材质',
    d98ArgumentValue18:'工业级ABS',
    d98ArgumentKey19:'工业等级',
    d98ArgumentValue19:'IP65',
    d98ArgumentKey20:'尺寸',
    d98ArgumentValue20:'64mm*62mm*19mm',
    d98ArgumentKey21:'重量',
    d98ArgumentValue21:'76.5g',
    d98ArgumentKey22:'工作温度',
    d98ArgumentValue22:'-20°C~70°C',
    d98ArgumentKey23:'存储温度',
    d98ArgumentValue23:'-40°C~80°C',
    d96Brighttext1:'IP65工业级设计 不惧雨淋冲洗',
    d92ArgumentValue1:'重启：短按开机键，绿灯闪烁2次；重启后首次数据上传成功绿灯常亮30秒，上传异常绿灯闪烁15秒',
    d92ArgumentValue2:'标配：2200mAH（选配：4400mAH）',
    d92ArgumentValue3:'5年1100次\\5000次',
    d82Brighttext1:'自定义上报频率',
    d82Brighttext2:'智能预警',
    d82Brighttext3:'资产绑定',
    d82Brighttext4:'IP53工业级设计',
    d82ArgumentKey1:'机身颜色',
    d82ArgumentValue1:'充电中：红色；充满：绿色',
    d82ArgumentValue2:'10米',
    d82ArgumentValue3:'10min/次（可自定义）',
    d82ArgumentValue4:'0.24mA',
    d82ArgumentValue5:'65uAH',
    d82ArgumentValue6:'标配：2000mAH（选配：3000mAH\\4000mAH）',
    d82ArgumentValue7:'5W（5V，1A）',
    d82ArgumentValue8:'MicroUSB',
    d82ArgumentValue9:'黑色',
    d82ArgumentValue10:'IP53',
    d82ArgumentValue11:'76mm*48mm*24.5mm',
    d82ArgumentValue12:'76.7g',
    d60Brighttext1:'多重定位，更精准',
    d60Brighttext2:'支持位置服务平台接入',
    d60Brighttext3:'免按开关 上电即工作',
    d60Brighttext4:'多重报警 及时发送报警信息',
    d60Brighttext5:'支持ACC检测 实时上报车辆状态',
    d60Brighttext6:'实时定位 只能上传位置信息',
    d60ArgumentKey1:'工作电压',
    d60ArgumentKey2:'工作电流',
    d60ArgumentKey3:'待机电流',
    d60ArgumentKey4:'陶瓷天线',
    d60ArgumentKey5:'通信网络',
    d60ArgumentKey6:'通讯制式',
    d60ArgumentKey7:'通讯协议',
    d60ArgumentValue1:'GPS+北斗+基站+AGPS',
    d60ArgumentValue2:'DC 9-90V',
    d60ArgumentValue3:'20~30mA@12V',
    d60ArgumentValue4:'小于1.6mA',
    d60ArgumentValue5:'内置GPS/BD 双模陶瓷天线',
    d60ArgumentValue6:'LTE',
    d60ArgumentValue7:'FDD:B1\\3\\5\\8 TDD:B34\\38\\39\\40\\41',
    d60ArgumentValue8:'JT808',
    d60ArgumentValue9:'80mm*32.5mm*13mm',
    d60ArgumentValue10:'36.7g',
    d60ArgumentValue11:'-25°C~70°C',
    d60ArgumentValue12:'-25°C~85°C',
    bTArgumentKey1:'广播周期',
    bTArgumentKey2:'固定方式',
    bTArgumentValue1:'蓝牙BLE 2.4G',
    bTArgumentValue2:'要配套D98BT使用，信标3秒间隔进行广播，空旷区传输距离25米',
    bTArgumentValue3:'3秒1次',
    bTArgumentValue4:'6.2uA',
    bTArgumentValue5:'3.0V',
    bTArgumentValue6:'5年',
    bTArgumentValue7:'300mAH',
    bTArgumentValue8:'工业级ABS+PC',
    bTArgumentValue9:'32mm*36mm*10mm',
    bTArgumentValue10:'11.5g',
    bTArgumentValue11:'-20°C~70°C',
    bTArgumentValue12:'-40°C~80°C',
    bTArgumentValue13:'3mm直径的铆钉或自攻螺丝',
  },
  dSVehiclePositioning:{
    vehicleTitle:'车载定位解决方案',
    issuesItemTitle1:'位置轨迹难监控',
    issuesItemtext1:'车辆的位置信息、空载情况、历史轨迹、里程统计无法实时监控，当遇到问题时无法问题追溯及优化作业流程',
    issuesItemTitle2:'车队难管理',
    issuesItemtext2:'物流企业不能及时、准确、全面的掌握运输车辆的信息，大多数管理方案不够灵活，缺少有针对性的专业化定制',
    issuesItemTitle3:'闲置率过高',
    issuesItemtext3:'车辆忙闲不均，闲置车辆过多，通常采用人工协调分配任务，无支撑系统，协调慢且调配不均，导致占用大量人力、维修、各类油耗成本资源',
    issuesItemTitle4:'行车安全难保障',
    issuesItemtext4:'司机超速行驶、疲劳驾驶，交通违规等不良行为，增加了货物运输过程中的安全隐患',
    issuesItemTitle5:'人工协调繁琐',
    issuesItemtext5:'通常采用人工协调分配任务，无支撑系统，协调慢且调配不均',
    solutionsLabel:'车载定位系统',
    solutionsText:'旭宇车载定位平台基于现代信息技术的综合性方案，整合物联网、大数据、云计算等先进技术，定位产品通过4G、5G网络，将车辆数据实时传输到后台管理系统。平台可以实时了解车辆的行驶轨迹、速度、停留等相关信息，为车辆调度、路线规划、故障预警、管理等提供有力的支撑。',
    nonParagraphText1:'实时定位',
    nonParagraphText2:'轨迹回放',
    nonParagraphText3:'实时告警',
    highlightsTitle:'核心亮点',
    highlightsText:'电脑端、小程序双平台',
    highlightsItemTitle1:'车辆实时定位',
    highlightsItemtext1:'实时查询车辆位置和状态，有效监控车辆',
    highlightsItemTitle2:'历史轨迹',
    highlightsItemtext2:'通过选择轨迹行驶时间段，查看车辆的历史行驶轨迹，以及车辆停车点信息',
    highlightsItemTitle3:'电子围栏',
    highlightsItemtext3:'对指定车辆的营运区域进行规范管理，车辆进入或者驶出时都会发出报警信号',
    highlightsItemTitle4:'异常报警',
    highlightsItemtext4:'多种智能预警，及时发出报警信号：如超速、长时间停留等',
    applicationSceneTitle:'应用场景',
    applicationSceneText1:'旭宇车载定位平台适用于',
    applicationSceneText2:'物流运输、车辆租赁、公共交通、教练车、机械车、私家车、两轮车',
    applicationSceneText3:'等多种场景，具有广阔的市场前景和巨大的应用价值。',
    sceneItemLabel1:'场景一 汽车金融风险管控',
    sceneItemLabel2:'场景二 政府公务车管理',
    sceneItemLabel3:'场景三 车辆租赁管理',
    sceneItemLabel4:'场景四 两轮车管理',
    sceneItemTitle1:'车辆位置追踪与失联问题',
    sceneItemText1:'通过旭宇实时定位功能，精确追踪到贷款车辆的位置，及时采取措施进行追回，降低资产损失',
    sceneItemTitle2:'贷后管理效率提升',
    sceneItemText2:'能够实时监控车辆的行驶状态和位置变化，及时发现异常行为，有助于风控公司更加精准地制定贷后管理策略，提高管理效率',
    sceneItemTitle3:'风险预警与欺诈识别',
    sceneItemText3:'旭宇定位器记录车辆的行驶轨迹和历史位置信息，通过对这些数据的分析，可以识别出潜在的欺诈行为，帮助风控公司及时发现并应对潜在风险',
    sceneItemTitle4:'提升催收效率与成功率',
    sceneItemText4:'在发生违约情况时，旭宇定位器能够帮助风控公司迅速定位到违约车辆的位置，为催收工作提供有力支持',
    sceneItemTitle5:'强化车辆管理与安全防盗',
    sceneItemText5:'旭宇定位器具备防盗报警功能，当车辆出现异常移动或被盗时，能够及时向管理者发送报警信息。这有助于管理者迅速采取措施，确保车辆的安全',
    sceneItemTitle6:'提高车辆调度与使用效率',
    sceneItemText6:'通过旭宇定位器，管理者可以实时了解车辆的分布和状态，从而更合理地调度车辆资源。这有助于减少车辆空驶和闲置时间，提高公务用车的使用效率',
    sceneItemTitle7:'避免车辆使用混乱与去向不明',
    sceneItemText7:'公务用车使用不规范或管理不善容易出现混乱情况，如车辆私自借用、去向不明等。旭宇定位器能够实时追踪车辆位置，准确掌握车辆动态，避免车辆被滥用',
    sceneItemTitle8:'监督驾驶行为与安全',
    sceneItemText8:'旭宇定位器可记录车辆的行驶轨迹和速度。这有助于管理者监督驾驶人员的行为，确保他们遵守交通规则，减少超速、违规行驶等不安全行为',
    sceneItemTitle9:'车辆位置追踪与防盗',
    sceneItemText9:'车辆租赁过程中，租赁公司面临车辆失窃或被非法转移的风险。旭宇定位器能够实时追踪车辆的位置，确保租赁公司能够随时掌握车辆动态',
    sceneItemTitle10:'减少骗租与逾期不还风险',
    sceneItemText10:'骗租和逾期不还是车辆租赁行业常见的风险。通过安装旭宇定位器，租赁公司可以实时监测车辆的行驶轨迹和位置变化，确保车辆按时归还，降低逾期不还的风险',
    sceneItemTitle11:'提升客户体验与服务质量',
    sceneItemText11:'通过旭宇定位器，租赁公司可为客户提供便捷和高效的服务。当客户需要紧急用车时，租赁公司可以迅速找到附近可用的车辆并提供给客户，帮助客户更加便捷地使用租赁车辆',
    sceneItemTitle12:'监督驾驶行为与安全',
    sceneItemText12:'在车辆租赁过程中，一旦发生事故，旭宇定位器能够提供车辆的行驶轨迹和位置信息，为事故调查和责任划分提供有力证据，公正地处理事故纠纷，维护自身权益',
    sceneItemTitle13:'车辆防盗与位置追踪',
    sceneItemText13:'两轮车由于其轻便和易于移动的特点，成为盗窃的目标。安装旭宇定位器，车主可实时追踪车辆的位置，一旦车辆被盗或发生异常移动，会迅速发出警报，帮助车主及时找回车辆，降低车辆被盗风险',
    sceneItemTitle14:'骑行安全监控',
    sceneItemText14:'部分骑行者可能存在超速、闯红灯等违规行为，这不仅影响交通秩序，还可能带来安全隐患。旭宇定位器可以记录车辆的行驶轨迹和速度，为骑行者或者共享企业提供行为反馈，规范骑行行为',
    sceneItemTitle15:'车辆精准管理',
    sceneItemText15:'对于电动车租赁或共享企业而言，车辆众多，管理难度大。旭宇定位器可以实时显示车辆的分布和状态，帮助企业实现对车辆的精准管理',
    sceneItemTitle16:'优化车辆管理与调度',
    sceneItemText16:'对于共享两轮电动车运营商而言，旭宇定位器能够提供实时的车辆位置信息，帮助运营商更加合理地调度和管理车辆资源，提高车辆的利用率和运营效率',
    locatorsTitle:'相关定位器'
  }
}